import SeoHead from '../../components/feature/SeoHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Compra de Coches Accidentados en Barcelona',
    description: 'Compramos coches accidentados al mejor precio en Barcelona. Colisión frontal, lateral, trasera, vuelco. Tasación en 24h, recogida gratis y pago inmediato.',
    provider: {
      '@type': 'AutoDealer',
      name: 'Desguace Barcelona',
      telephone: '+34932932913',
      address: { '@type': 'PostalAddress', addressLocality: 'Barcelona', addressCountry: 'ES' },
    },
    areaServed: { '@type': 'AdministrativeArea', name: 'Provincia de Barcelona' },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '¿Compran coches accidentados aunque no estén declarados siniestro total?',
        acceptedAnswer: { '@type': 'Answer', text: 'Sí, compramos cualquier coche accidentado independientemente de si ha sido declarado siniestro total o no.' },
      },
      {
        '@type': 'Question',
        name: '¿Qué pasa si el coche tiene los airbags activados?',
        acceptedAnswer: { '@type': 'Answer', text: 'Los airbags activados no son un problema. Aunque reducen el valor del vehículo, el resto de piezas pueden tener mucho valor. Evaluamos el coche completo y te ofrecemos un precio justo.' },
      },
      {
        '@type': 'Question',
        name: '¿Ofrecen más dinero que la aseguradora por el salvamento?',
        acceptedAnswer: { '@type': 'Answer', text: 'En muchos casos sí. Las aseguradoras suelen ofrecer un valor residual conservador. Nosotros evaluamos cada pieza individualmente y podemos ofrecer precios superiores en la mayoría de los casos.' },
      },
    ],
  },
];

export default function VenderCocheAccidentadoPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Vender Coche Accidentado en Barcelona | Mejor Precio | Desguace Barcelona"
        description="Compramos tu coche accidentado al mejor precio en Barcelona. Cualquier tipo de accidente: frontal, lateral, vuelco. Tasación gratuita en 24h y recogida gratis."
        keywords="vender coche accidentado Barcelona, coche con daños Barcelona, compra coches accidentados Barcelona, desguace accidentados Barcelona"
        canonical={`${siteUrl}/vender-coche-accidentado-barcelona`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Vender Coche Accidentado en Barcelona
            </h1>
            <p className="text-xl text-white/90 leading-relaxed mb-8">
              Compramos tu coche accidentado al mejor precio. Tasación gratuita en 24h y recogida gratis en toda Barcelona
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20valorar%20mi%20coche%20accidentado" 
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center justify-center px-10 py-5 bg-[#25D366] text-white rounded-full font-bold text-lg hover:bg-[#1fb855] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3 text-2xl"></i>
                WhatsApp
              </a>
              <a 
                href="tel:+34932932913" 
                className="inline-flex items-center justify-center px-10 py-5 bg-white text-[#1a2332] rounded-full font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-3"></i>
                932 932 913
              </a>
            </div>
          </div>
        </section>

        {/* Señales de Confianza */}
        <section className="py-12 bg-[#f8f9fa]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-money-euro-circle-line text-white text-3xl"></i>
                </div>
                <p className="font-bold text-[#1a2332] text-sm">Mejor Precio</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-truck-line text-white text-3xl"></i>
                </div>
                <p className="font-bold text-[#1a2332] text-sm">Recogida Gratis</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-time-line text-white text-3xl"></i>
                </div>
                <p className="font-bold text-[#1a2332] text-sm">Proceso Rápido</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-white text-3xl"></i>
                </div>
                <p className="font-bold text-[#1a2332] text-sm">100% Legal</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contenido Principal */}
        <article className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            
            {/* Introducción */}
            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                ¿Has tenido un accidente de tráfico en Barcelona y tu coche ha quedado dañado? En <strong>Desguace Barcelona</strong> compramos coches accidentados de cualquier marca y modelo, ofreciendo el mejor precio del mercado y un servicio completamente profesional. Con más de 15 años de experiencia, somos la opción preferida por miles de conductores en Barcelona y provincia.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                No importa la gravedad del accidente: colisión frontal, lateral, trasera, vuelco o cualquier otro tipo de siniestro. Evaluamos cada vehículo de forma individual y te ofrecemos una tasación justa y transparente basada en el valor real de las piezas recuperables y el estado del coche.
              </p>
            </div>

            {/* Sección 1 */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                ¿Qué es un Coche Accidentado?
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Un <strong>coche accidentado</strong> es cualquier vehículo que ha sufrido daños como consecuencia de una colisión, impacto o accidente de tráfico. Estos daños pueden variar desde pequeños golpes en la carrocería hasta daños estructurales graves que afectan al chasis, motor o sistemas de seguridad del vehículo.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8">
                Muchas personas confunden los términos "coche accidentado" y "coche siniestrado", pero hay una diferencia importante: un coche siniestrado es aquel que ha sido declarado oficialmente como <strong>siniestro total</strong> por una compañía de seguros, mientras que un coche accidentado puede tener daños sin haber sido declarado siniestro total.
              </p>

              <div className="bg-[#f8f9fa] p-8 rounded-2xl mb-8">
                <h3 className="text-2xl font-bold text-[#1a2332] mb-4">Tipos de Accidentes que Compramos</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Colisión Frontal:</strong>
                      <p className="text-gray-700">Impactos en la parte delantera del vehículo que pueden afectar al motor, radiador, capó y sistemas de seguridad como airbags.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Colisión Lateral:</strong>
                      <p className="text-gray-700">Golpes en los laterales del coche que dañan puertas, ventanas, pilares y pueden comprometer la estructura del vehículo.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Colisión Trasera:</strong>
                      <p className="text-gray-700">Impactos en la parte posterior que afectan al maletero, luces traseras, paragolpes y pueden dañar el depósito de combustible.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Vuelco o Volcado:</strong>
                      <p className="text-gray-700">Vehículos que han volcado completamente, con daños en el techo, pilares, cristales y posibles daños estructurales graves.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Atropello o Impacto con Peatón:</strong>
                      <p className="text-gray-700">Daños en la parte frontal del vehículo, capó, parabrisas y sistemas de seguridad activados.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Múltiples Impactos:</strong>
                      <p className="text-gray-700">Vehículos que han sufrido varios golpes en diferentes zonas, común en accidentes en cadena o colisiones múltiples.</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Sección 2 */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Ventajas de Vender tu Coche Accidentado a Desguace Barcelona
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white border-2 border-[#1a2332] p-6 rounded-xl">
                  <div className="w-14 h-14 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-money-euro-circle-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Mejor Precio del Mercado</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Evaluamos cada pieza recuperable del vehículo para ofrecerte el máximo valor. Nuestros precios superan habitualmente las ofertas de aseguradoras y otros desguaces de Barcelona.
                  </p>
                </div>

                <div className="bg-white border-2 border-[#1a2332] p-6 rounded-xl">
                  <div className="w-14 h-14 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-time-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Tasación en 24 Horas</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Recibe una oferta detallada en menos de 24 horas. Solo necesitamos fotos del vehículo y algunos datos básicos para hacer una valoración precisa.
                  </p>
                </div>

                <div className="bg-white border-2 border-[#1a2332] p-6 rounded-xl">
                  <div className="w-14 h-14 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-truck-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Recogida Gratuita</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Recogemos tu coche accidentado donde esté: en tu casa, en un taller, en la calle o en el depósito de la grúa. Servicio 100% gratuito en toda Barcelona y provincia.
                  </p>
                </div>

                <div className="bg-white border-2 border-[#1a2332] p-6 rounded-xl">
                  <div className="w-14 h-14 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Proceso 100% Legal</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Gestionamos toda la documentación: certificado de destrucción, baja en la DGT y notificación a tu aseguradora. Todo completamente legal y sin complicaciones.
                  </p>
                </div>

                <div className="bg-white border-2 border-[#1a2332] p-6 rounded-xl">
                  <div className="w-14 h-14 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-hand-coin-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Pago Inmediato</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Cobramos en el momento de la recogida: transferencia bancaria instantánea o efectivo. No tendrás que esperar días o semanas para recibir tu dinero.
                  </p>
                </div>

                <div className="bg-white border-2 border-[#1a2332] p-6 rounded-xl">
                  <div className="w-14 h-14 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-customer-service-2-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Atención Personalizada</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Un asesor experto te acompañará durante todo el proceso, resolviendo todas tus dudas y asegurándose de que todo salga perfecto.
                  </p>
                </div>
              </div>
            </section>

            {/* Sección 3 */}
            <section className="mb-16 bg-gradient-to-br from-[#f8f9fa] to-[#e8f0f7] p-8 rounded-2xl">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Proceso Paso a Paso para Vender tu Coche Accidentado
              </h2>
              
              <div className="space-y-6">
                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#1a2332] text-white rounded-full flex items-center justify-center font-black text-lg">
                      1
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-[#1a2332] mb-2">Solicita tu Tasación</h4>
                      <p className="text-gray-600 leading-relaxed">
                        Llámanos al teléfono o rellena el formulario online. Necesitamos: matrícula, marca, modelo, año y fotos de los daños. Cuanta más información nos proporciones, más precisa será la tasación.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#1a2332] text-white rounded-full flex items-center justify-center font-black text-lg">
                      2
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-[#1a2332] mb-2">Recibe tu Oferta en 24h</h4>
                      <p className="text-gray-600 leading-relaxed">
                        Nuestro equipo de expertos analiza el estado del vehículo y el valor de las piezas recuperables. En menos de 24 horas recibirás una oferta detallada, transparente y sin compromiso.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#1a2332] text-white rounded-full flex items-center justify-center font-black text-lg">
                      3
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-[#1a2332] mb-2">Acepta la Oferta</h4>
                      <p className="text-gray-600 leading-relaxed">
                        Si estás de acuerdo con el precio, simplemente confirma tu aceptación. No hay letra pequeña ni costes ocultos. El precio que te ofrecemos es el precio que recibirás.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#1a2332] text-white rounded-full flex items-center justify-center font-black text-lg">
                      4
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-[#1a2332] mb-2">Programamos la Recogida</h4>
                      <p className="text-gray-600 leading-relaxed">
                        Acordamos día y hora según tu disponibilidad. Nuestro equipo se desplaza a donde esté el vehículo: tu domicilio, taller, depósito de grúa o cualquier otro lugar en Barcelona y provincia.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#1a2332] text-white rounded-full flex items-center justify-center font-black text-lg">
                      5
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-[#1a2332] mb-2">Recogida y Pago Inmediato</h4>
                      <p className="text-gray-600 leading-relaxed">
                        Verificamos el estado del vehículo, firmamos la documentación de compraventa y realizamos el pago en el acto: transferencia bancaria o efectivo. Nos llevamos el coche y tú recibes tu dinero.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl shadow-sm">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#1a2332] text-white rounded-full flex items-center justify-center font-black text-lg">
                      6
                    </div>
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-[#1a2332] mb-2">Gestión Legal Completa</h4>
                      <p className="text-gray-600 leading-relaxed">
                        Nos encargamos de todos los trámites: certificado de destrucción, baja en Tráfico y notificación a la aseguradora. Recibirás toda la documentación que acredita la baja legal del vehículo.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Sección 4 */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                ¿Cuánto Vale un Coche Accidentado?
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                El valor de un coche accidentado depende de múltiples factores. En <strong>Desguace Barcelona</strong> realizamos una evaluación exhaustiva para ofrecerte el mejor precio posible:
              </p>

              <div className="bg-[#f8f9fa] p-8 rounded-2xl mb-8">
                <h3 className="text-2xl font-bold text-[#1a2332] mb-4">Factores que Determinan el Precio</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Gravedad de los Daños:</strong>
                      <p className="text-gray-700">Evaluamos qué partes están dañadas y cuáles pueden recuperarse. Un coche con daños solo en la carrocería vale más que uno con motor dañado.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Marca y Modelo:</strong>
                      <p className="text-gray-700">Las piezas de marcas premium (BMW, Mercedes, Audi) tienen mayor demanda y valor en el mercado de recambios.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Año y Kilometraje:</strong>
                      <p className="text-gray-700">Vehículos más recientes y con menos kilómetros tienen piezas en mejor estado y mayor valor de reventa.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Piezas Recuperables:</strong>
                      <p className="text-gray-700">Motor, caja de cambios, electrónica, ópticas, llantas... Cada pieza en buen estado suma valor al vehículo.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Demanda de Piezas:</strong>
                      <p className="text-gray-700">Modelos populares con alta demanda de recambios tienen mejor valoración en el mercado de desguace.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#ff6b35] text-2xl flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-[#1a2332]">Peso del Vehículo:</strong>
                      <p className="text-gray-700">El valor del metal y materiales reciclables también se tiene en cuenta en la tasación final.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-[#ff6b35]/10 to-[#ff6b35]/5 border-l-4 border-[#ff6b35] p-6 rounded-r-xl">
                <p className="text-gray-700 leading-relaxed">
                  <strong className="text-[#1a2332]">💡 Consejo:</strong> Aunque tu coche parezca no tener valor, siempre hay piezas recuperables. Incluso vehículos con daños muy graves pueden tener motor, transmisión, electrónica o piezas de interior en perfecto estado. ¡Solicita tu tasación gratuita y descubre cuánto vale tu coche accidentado!
                </p>
              </div>
            </section>

            {/* Sección 5 */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Diferencia entre Coche Siniestrado y Coche Accidentado
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Muchas personas usan estos términos indistintamente, pero hay diferencias importantes:
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white border-2 border-[#1a2332] p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3 flex items-center gap-2">
                    <i className="ri-car-line text-[#ff6b35]"></i>
                    Coche Accidentado
                  </h3>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#ff6b35] mt-1 flex-shrink-0"></i>
                      <span>Ha sufrido un accidente con daños visibles</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#ff6b35] mt-1 flex-shrink-0"></i>
                      <span>No necesariamente declarado por el seguro</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#ff6b35] mt-1 flex-shrink-0"></i>
                      <span>Puede ser reparable económicamente</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#ff6b35] mt-1 flex-shrink-0"></i>
                      <span>El propietario decide si reparar o vender</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-white border-2 border-[#ff6b35] p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3 flex items-center gap-2">
                    <i className="ri-alert-line text-[#ff6b35]"></i>
                    Coche Siniestrado
                  </h3>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#ff6b35] mt-1 flex-shrink-0"></i>
                      <span>Declarado oficialmente como siniestro total</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#ff6b35] mt-1 flex-shrink-0"></i>
                      <span>El coste de reparación supera el 60-80% del valor</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#ff6b35] mt-1 flex-shrink-0"></i>
                      <span>La aseguradora lo ha evaluado y declarado</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-[#ff6b35] mt-1 flex-shrink-0"></i>
                      <span>Generalmente no es rentable repararlo</span>
                    </li>
                  </ul>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed">
                <strong>En Desguace Barcelona compramos ambos tipos de vehículos.</strong> Ya sea que tu coche haya sido declarado siniestro total por el seguro o simplemente haya sufrido un accidente y prefieras venderlo en lugar de repararlo, te ofrecemos la mejor solución del mercado.
              </p>
            </section>

            {/* Sección 6 - FAQ */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Preguntas Frecuentes sobre Coches Accidentados
              </h2>

              <div className="space-y-4">
                <div className="bg-white border-l-4 border-[#ff6b35] p-6 rounded-r-xl shadow-sm">
                  <h4 className="text-lg font-bold text-[#1a2332] mb-2">
                    ¿Compran coches accidentados aunque no estén declarados siniestro total?
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    Sí, compramos cualquier coche accidentado independientemente de si ha sido declarado siniestro total o no. Muchos propietarios prefieren vender su coche accidentado en lugar de afrontar una reparación costosa, y nosotros ofrecemos una solución rápida y rentable.
                  </p>
                </div>

                <div className="bg-white border-l-4 border-[#ff6b35] p-6 rounded-r-xl shadow-sm">
                  <h4 className="text-lg font-bold text-[#1a2332] mb-2">
                    ¿Necesito tener el parte del accidente para vender el coche?
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    No es imprescindible. Aunque el parte del accidente puede ayudar a entender mejor los daños, no es un requisito obligatorio. Lo más importante es que tengas la documentación del vehículo (permiso de circulación y ficha técnica) y que seas el propietario legal.
                  </p>
                </div>

                <div className="bg-white border-l-4 border-[#ff6b35] p-6 rounded-r-xl shadow-sm">
                  <h4 className="text-lg font-bold text-[#1a2332] mb-2">
                    ¿Qué pasa si el coche tiene los airbags activados?
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    Los airbags activados no son un problema. Aunque reducen el valor del vehículo (ya que son costosos de reemplazar), el resto de piezas pueden tener mucho valor. Evaluamos el coche completo y te ofrecemos un precio justo considerando todos los componentes recuperables.
                  </p>
                </div>

                <div className="bg-white border-l-4 border-[#ff6b35] p-6 rounded-r-xl shadow-sm">
                  <h4 className="text-lg font-bold text-[#1a2332] mb-2">
                    ¿Puedo vender un coche accidentado si todavía debo dinero del préstamo?
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    Sí, es posible, pero deberás saldar la deuda con el banco antes de transferir la propiedad. En algunos casos, si el valor del coche cubre el préstamo restante, podemos ayudarte a coordinar el pago directamente con la entidad financiera.
                  </p>
                </div>

                <div className="bg-white border-l-4 border-[#ff6b35] p-6 rounded-r-xl shadow-sm">
                  <h4 className="text-lg font-bold text-[#1a2332] mb-2">
                    ¿Compran coches accidentados de cualquier marca?
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    Sí, compramos coches accidentados de todas las marcas: Seat, Volkswagen, Renault, Peugeot, Citroën, Ford, Opel, BMW, Mercedes, Audi, Toyota, Nissan, Hyundai, Kia y cualquier otra marca del mercado. También compramos vehículos comerciales, furgonetas y todoterrenos.
                  </p>
                </div>

                <div className="bg-white border-l-4 border-[#ff6b35] p-6 rounded-r-xl shadow-sm">
                  <h4 className="text-lg font-bold text-[#1a2332] mb-2">
                    ¿Cuánto tiempo tarda el proceso completo?
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    El proceso completo suele tardar entre 3 y 5 días laborables. La tasación la realizamos en menos de 24 horas, y la recogida se programa según tu disponibilidad. El pago se realiza en el momento de la recogida, y los trámites legales los gestionamos nosotros en los días siguientes.
                  </p>
                </div>

                <div className="bg-white border-l-4 border-[#ff6b35] p-6 rounded-r-xl shadow-sm">
                  <h4 className="text-lg font-bold text-[#1a2332] mb-2">
                    ¿Qué documentación necesito para vender mi coche accidentado?
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    Necesitas: DNI o NIE del propietario, permiso de circulación original, ficha técnica del vehículo y, si es posible, el último recibo del seguro. Si falta algún documento, podemos asesorarte sobre cómo obtenerlo o buscar soluciones alternativas.
                  </p>
                </div>

                <div className="bg-white border-l-4 border-[#ff6b35] p-6 rounded-r-xl shadow-sm">
                  <h4 className="text-lg font-bold text-[#1a2332] mb-2">
                    ¿Ofrecen más dinero que la aseguradora por el salvamento?
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    En muchos casos sí. Las aseguradoras suelen ofrecer un valor residual (salvamento) conservador. Nosotros evaluamos cada pieza individualmente y, gracias a nuestra experiencia y red de clientes, podemos ofrecer precios superiores en la mayoría de los casos.
                  </p>
                </div>
              </div>
            </section>

            {/* Sección 7 */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Zonas de Barcelona Donde Compramos Coches Accidentados
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Ofrecemos servicio de recogida gratuita en toda Barcelona y provincia:
              </p>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                {['Barcelona Ciudad', 'Badalona', 'L\'Hospitalet', 'Sabadell', 'Terrassa', 'Mataró', 'Granollers', 'Vilafranca', 'Sant Cugat', 'Cornellà', 'Rubí', 'Manresa', 'Vilanova', 'Gavà', 'Castelldefels', 'Provincia'].map((zona, index) => (
                  <div key={index} className="bg-[#f8f9fa] p-3 rounded-lg text-center">
                    <i className="ri-map-pin-line text-[#ff6b35] mr-1"></i>
                    <span className="text-sm font-medium text-[#1a2332]">{zona}</span>
                  </div>
                ))}
              </div>
            </section>

            {/* CTA Final */}
            <section className="bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-2xl p-12 text-center text-white">
              <h2 className="text-4xl font-black mb-4">
                Vende tu Coche Accidentado Hoy
              </h2>
              <p className="text-xl mb-8 text-white/90">
                Mejor precio garantizado • Recogida gratis • Pago inmediato
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20valorar%20mi%20coche%20accidentado" 
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center justify-center px-10 py-5 bg-[#25D366] text-white rounded-full font-bold text-lg hover:bg-[#1fb855] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-3 text-2xl"></i>
                  Solicitar Tasación
                </a>
                <a 
                  href="tel:+34932932913" 
                  className="inline-flex items-center justify-center px-10 py-5 bg-white text-[#1a2332] rounded-full font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-3"></i>
                  932 932 913
                </a>
              </div>
            </section>

          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
